import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./i18n";
import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';

// Suppress the benign ResizeObserver loop warning triggered by Recharts/ResponsiveContainer
const originalError = window.onerror;
window.onerror = (message, ...rest) => {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
    return true; // suppress
  }
  return originalError ? originalError(message, ...rest) : false;
};
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
});

// Selecciona el contenedor donde se montará la aplicación
const rootElement = document.getElementById("root");

// Usa createRoot en lugar de render
const root = ReactDOM.createRoot(rootElement);

root.render(
  <Router>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Router>
);
